import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import Alert from "../../../component/Alert";
import { categoryData } from "../../../globalApi/GlobalApi";
import Popup from "../../popupmodal/Popup";
import { bankData } from "../../../globalApi/GlobalApi";

export default function QuotationAdd() {
  const today = new Date().toISOString().split("T")[0];
  const storedBranchArray =
    JSON.parse(sessionStorage.getItem("branchNames")) || [];

  let companyName = sessionStorage.getItem("companyName");
  const [selectedBankValue, setSelectedBankValue] = useState("");

  const [selectBranch, setSelectedBranch] = useState(null);
  const [interestStatus, setInterestStatus] = useState("Interested");
  const [convertedStatus, setConvertedStatus] = useState("Not Converted");
  const [selectedValue, setSelectedValue] = useState("");
  // let billDetails = JSON.parse(sessionStorage.getItem("billDetails"));

  const [selectCategory, setSelectedCategory] = useState(null);
  const [proformaData, setProformaData] = useState(null);

  const navigate = useNavigate();
  const { state } = useLocation();
  // console.log("state", state);

  const {
    control,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      formValue: [{ item: "", description: "", qty: null, price: null }],
      actualAmount: null,
      discount: null,
      percentage: null,
      totalInvoiceAmount: null,
      paymentSplits: [
        {
          amountInSplit: 0,
          description: "",
          descriptionPercentage: 0,
        },
      ],
      quotationDate: today,
      siteVisitDate: today,
    },
  });

  const { billName } = watch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { fields, append, remove, replace } = useFieldArray({
    name: "formValue",
    control,
  });
  const {
    fields: paymentSplit,
    append: paymentAppend,
    remove: paymentRemove,
    replace: paymentReplace,
  } = useFieldArray({
    name: "paymentSplits",
    control,
  });

  const descriptionCount = useWatch({ control, name: "descriptionCount" });
  const paymentSplitting = useWatch({ control, name: "paymentSplitting" });
  const paymentSplits = useWatch({ control, name: "paymentSplits" });
  const formValue = useWatch({ control, name: "formValue" });

  // Handle paymentSplitting change
  React.useEffect(() => {
    if (paymentSplitting === "other") {
      paymentReplace([]); // Clear old
      setValue("descriptionCount", ""); // Clear manual count input
    } else if (paymentSplitting) {
      const splitCount = parseInt(paymentSplitting, 10) || 0;
      const newFields = Array.from({ length: splitCount }, () => ({
        amountInSplit: 0,
        description: "",
      }));
      paymentReplace(newFields);
      setValue("descriptionCount", "");
    }
  }, [paymentSplitting, paymentReplace, setValue]);

  // Handle manual descriptionCount change
  React.useEffect(() => {
    if (paymentSplitting === "other") {
      if (!descriptionCount || isNaN(descriptionCount)) {
        // If cleared or not a number, remove all fields
        paymentReplace([]);
      } else {
        const splitCount = parseInt(descriptionCount, 10) || 0;
        const newFields = Array.from({ length: splitCount }, () => ({
          amountInSplit: 0,
          description: "",
        }));
        paymentReplace(newFields);
      }
    }
  }, [descriptionCount, paymentSplitting, paymentReplace]);

  // GET API START
  const quotationData = async () => {
    return await axios.get(
      `${process.env.REACT_APP_HOST}/quotation/${selectBranch}/all`
    );
  };

  const { data: quotationGet } = useQuery(
    ["quotationData", selectBranch],
    quotationData,
    {
      enabled: !!selectBranch,
      refetchOnWindowFocus: false,
    }
  );
  // GET API END

  let details = (quotationGet && quotationGet?.data) || [];

  let customerDetails = null;

  if (selectedValue?.trim()) {
    const [namePart, mobilePart] = selectedValue
      .split(":")
      .map((s) => s.trim());

    customerDetails =
      details &&
      details.find(
        (data) =>
          data?.customerName?.toLowerCase() === namePart?.toLowerCase() &&
          data?.mobileNumber === mobilePart
      );
  }

  // GET API FOR CATEGORYNAMES
  const {
    data: categoryList,
    isLoading: categoryLoading,
    isError,
    refetch,
  } = useQuery("categoryData", categoryData, {
    refetchOnWindowFocus: false,
    enabled: true,
  });

  // Category Filter

  let categoryDetails = (categoryList && categoryList?.data) || [];

  let categoryArray = categoryDetails?.map((data) => {
    return data?.categoryName;
  });

  let termsandcon = categoryDetails?.find((data, i) => {
    return data?.categoryName == selectCategory;
  });

  // GET API START FOR BANK DETAILS
  const bankData = async (companyName) => {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/register/byCompanyName`,
      { params: { companyName } } // Sending branchName as a parameter
    );
    return response.data; // Returning the data from the response
  };

  const { data: bankDetails, isLoading: bankLoading } = useQuery(
    ["bankData", companyName],
    () => bankData(companyName),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(companyName),
    }
  );

  // GET API END

  // GET API START FOR BRANCH DETAILS
  const branchData = async (branchName) => {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/branches/bybranchname`,
      { params: { branchName } } // Sending branchName as a parameter
    );
    return response.data; // Returning the data from the response
  };

  const { data: branchDetails, isLoading: branchLoading } = useQuery(
    ["branchData", selectBranch],
    () => branchData(selectBranch),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(selectBranch),
    }
  );
  // GET API END

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/quotation/${selectBranch}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // Rethrow to trigger onError
      }
    },
    {
      onSuccess: () => {
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add quotation",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to add quotation. Please try again.");
      },
    }
  );
  //

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/quotation/${selectBranch}/${state?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add quotation",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the quotation. Please try again.");
      },
    }
  );

  // SETVALUE FOR STATE VALUES
  useEffect(() => {
    if (state?.id) {
      setValue("billName", state?.billName);
      setValue("billNo", state?.billNo);
      setValue("branch", state?.branch);
      setValue("acNo", state?.acNo);
      setValue("bankName", state?.bankName);
      setValue("bankPhoneNumber", state?.bankPhoneNumber);
      setValue("billAlterNumber", state?.billAlterNumber);
      setValue("billCity", state?.billCity);
      setValue("billGstIn", state?.billGstIn);
      setValue("billLocality", state?.billLocality);
      setValue("billPhoneNumber", state?.billPhoneNumber);
      setValue("billPinCode", state?.billPinCode);
      setValue("billStreet", state?.billStreet);
      setValue("category", state?.category);
      setValue("city", state?.city);
      setValue("currentAccHolderName", state?.currentAccHolderName);
      setValue("customerName", state?.customerName);
      setValue("discount", state?.discount);
      setValue("doorNo", state?.doorNo);
      setValue("gstIn", state?.gstIn);
      setValue("ifscCode", state?.ifscCode);
      setValue("kindAttn", state?.kindAttn);
      setValue("locality", state?.locality);
      setValue("mobileNumber", state?.mobileNumber);
      setValue("natureOfBusiness", state?.natureOfBusiness);
      setValue("paymentSplitting", state?.paymentSplitting);
      setValue("percentage", state?.percentage);
      setValue("pincode", state?.pincode);
      setValue("proposal", state?.proposal);
      setValue("quotationDate", state?.quotationDate);
      setValue("quotationNo", state?.quotationNo);
      setValue("branchSelect", state?.branchSelect);
      setSelectedBranch(state?.branchSelect);
      setValue("siteAddress", state?.siteAddress);
      setValue("siteVisitDate", state?.siteVisitDate);
      setValue("specifications", state?.specifications);
      setValue("state", state?.state);
      setValue("street", state?.street);
      setValue("categoryType", state?.categoryType || null);
      setValue("otherCategoryType", state?.otherCategoryType || null);
      setValue("roundOff", state?.roundOff || null);

      if (state?.forms?.length > 0) {
        replace(
          state?.forms?.map((item) => ({
            item: item?.item || null,
            description: item?.description || null,
            qty: item?.qty || null,
            total: item?.total || null,
            price: item?.price || null,
          }))
        );
      }
      if (state?.paymentSplits?.length > 0) {
        paymentReplace(
          state?.paymentSplits?.map((item) => ({
            amountInSplit: item?.amountInSplit || null,
            description: item?.description || null,
            descriptionPercentage: item?.descriptionPercentage || null,
          }))
        );
      }
    }
    setValue("termsAndConditions", state?.termsAndConditions);
    setValue("actualAmount", state?.actualAmount || null);
    setValue("totalInvoiceAmount", state?.totalInvoiceAmount || null);
    setValue("customerGstIn", state?.customerGstIn || null);
  }, [state, setValue, replace, paymentReplace]);

  useEffect(() => {
    if (customerDetails && selectedValue) {
      setValue("branchSelect", customerDetails?.branchSelect || "");
      setValue("customerName", customerDetails?.customerName || "");
      setValue("kindAttn", customerDetails?.kindAttn || "");
      setValue("mobileNumber", customerDetails?.mobileNumber || "");
      setValue("doorNo", customerDetails?.doorNo || "");
      setValue("street", customerDetails?.street || "");
      setValue("locality", customerDetails?.locality || "");
      setValue("city", customerDetails?.city || "");
      setValue("state", customerDetails?.state || "");
      setValue("pincode", customerDetails?.pincode || "");
      setValue("natureOfBusiness", customerDetails?.natureOfBusiness || "");
      setValue("siteAddress", customerDetails?.siteAddress || "");
      setValue("siteVisitDate", customerDetails?.siteVisitDate || "");
      setValue("proposal", customerDetails?.proposal || "");
      setValue("percentage", customerDetails?.percentage || "");
      setValue("discount", customerDetails?.discount || "");
      setValue("totalInvoiceAmount", customerDetails?.totalInvoiceAmount || "");
      setValue("customerGstIn", customerDetails?.customerGstIn || "");
      setValue("categoryType", customerDetails?.categoryType || null);
      setValue("otherCategoryType", customerDetails?.otherCategoryType || null);
      setValue("roundOff", customerDetails?.roundOff || null);
      if (customerDetails?.forms?.length > 0) {
        replace(
          customerDetails?.forms?.map((item) => ({
            item: item?.item || null,
            description: item?.description || null,
            qty: item?.qty || null,
            total: item?.total || null,
            price: item?.price || null,
          }))
        );
      }
    }
  }, [customerDetails, setValue, selectedValue, replace]);

  // Branch Details setValue
  useEffect(() => {
    if (branchDetails && branchDetails != null) {
      setValue("billName", branchDetails?.branchName || "");
      setValue("billNo", branchDetails?.no || "");
      setValue("billStreet", branchDetails?.street || state?.street || "");
      setValue("billLocality", branchDetails?.locality || "");
      setValue("billCity", branchDetails?.city || "");
      setValue("billPinCode", branchDetails?.pincode || "");
      setValue("billPhoneNumber", branchDetails?.phoneNo || "");
      setValue("billAlterNumber", branchDetails?.altPhoneNo || "");
      setValue("billGstIn", branchDetails?.gstIn || "");
    }
  }, [setValue, branchDetails]);

  // BANK DETAILS

  // useEffect(() => {
  //   if (bankDetails && bankDetails != null) {
  //     setValue(
  //       "currentAccHolderName",
  //       bankDetails?.currentAccHolderName || null
  //     );
  //     setValue("bankName", bankDetails?.bankName || null);
  //     setValue("acNo", bankDetails?.accNo || null);
  //     setValue("ifscCode", bankDetails?.ifscCode || null);
  //     setValue("branch", bankDetails?.branch || null);
  //     setValue("bankPhoneNumber", bankDetails?.phoneNo || null);
  //   } else {
  //     setValue("currentAccHolderName", null);
  //     setValue("bankName", null);
  //     setValue("acNo", null);
  //     setValue("ifscCode", null);
  //     setValue("branch", null);
  //     setValue("bankPhoneNumber", null);
  //   }
  // }, [setValue, bankDetails]);

  useEffect(() => {
    if (bankDetails?.length && selectedBankValue) {
      const match = bankDetails?.find(
        (data) =>
          `${data.currentAccHolderName} : ${data?.accNo}` === selectedBankValue
      );

      if (match) {
        setValue("currentAccHolderName", match?.currentAccHolderName || null);
        setValue("bankName", match?.bankName || null);
        setValue("acNo", match?.accNo || null);
        setValue("ifscCode", match?.ifscCode || null);
        setValue("branch", match?.branch || null);
        setValue("bankPhoneNumber", match?.phoneNo || null);
      } else {
        // No match found, reset the fields
        setValue("currentAccHolderName", null);
        setValue("bankName", null);
        setValue("acNo", null);
        setValue("ifscCode", null);
        setValue("branch", null);
        setValue("bankPhoneNumber", null);
      }
    } else {
      // Optional: reset if selectedBankValue is empty or no bankDetails
      setValue("currentAccHolderName", null);
      setValue("bankName", null);
      setValue("acNo", null);
      setValue("ifscCode", null);
      setValue("branch", null);
      setValue("bankPhoneNumber", null);
    }
  }, [bankDetails, selectedBankValue, setValue]);

  // CATEGORY DETAILS
  useEffect(() => {
    if (termsandcon && !categoryLoading) {
      setValue("termsAndConditions", termsandcon?.termsAndConditions || null);
    }
  }, [termsandcon, categoryLoading, categoryDetails]);

  // DUPLICATE ENTRY
  useEffect(() => {
    const duplicateData = JSON.parse(localStorage.getItem("duplicateData"));
    console.log("data", duplicateData);
    if (duplicateData) {
      setValue("gstIn", duplicateData?.gstIn || "");
      setValue("billName", duplicateData?.billName || "");
      setValue("billNo", duplicateData?.billNo || "");
      setValue("branch", duplicateData?.branch || "");
      setValue("acNo", duplicateData?.acNo || "");
      setValue("bankName", duplicateData?.bankName || "");
      setValue("bankPhoneNumber", duplicateData?.bankPhoneNumber || "");
      setValue("billAlterNumber", duplicateData?.billAlterNumber || "");
      setValue("billCity", duplicateData?.billCity || "");
      setValue("billGstIn", duplicateData?.billGstIn || "");
      setValue("billLocality", duplicateData?.billLocality || "");
      setValue("billPhoneNumber", duplicateData?.billPhoneNumber || "");
      setValue("billPinCode", duplicateData?.billPinCode || "");
      setValue("billStreet", duplicateData?.billStreet || "");
      setValue("category", duplicateData?.category || "");
      setSelectedCategory(duplicateData?.category);
      setValue("city", duplicateData?.city || "");
      setValue(
        "currentAccHolderName",
        duplicateData?.currentAccHolderName || ""
      );
      setValue("customerName", duplicateData?.customerName || "");
      setValue("discount", duplicateData?.discount || "");
      setValue("doorNo", duplicateData?.doorNo || "");

      setValue("ifscCode", duplicateData?.ifscCode || "");
      setValue("kindAttn", duplicateData?.kindAttn || "");
      setValue("locality", duplicateData?.locality || "");
      setValue("mobileNumber", duplicateData?.mobileNumber || "");
      setValue("natureOfBusiness", duplicateData?.natureOfBusiness || "");
      setValue("paymentSplitting", duplicateData?.paymentSplitting || "");
      setValue("percentage", duplicateData?.percentage || "");
      setValue("pincode", duplicateData?.pincode || "");
      setValue("proposal", duplicateData?.proposal || "");
      setValue("quotationDate", duplicateData?.quotationDate || "");
      setValue("branchSelect", duplicateData?.branchSelect || "");
      setSelectedBranch(duplicateData?.branchSelect);
      setValue("siteAddress", duplicateData?.siteAddress || "");
      setValue("siteVisitDate", duplicateData?.siteVisitDate || "");
      setValue("specifications", duplicateData?.specifications || "");
      setValue("state", duplicateData?.state || "");
      setValue("street", duplicateData?.street || "");
      setValue("termsAndConditions", duplicateData?.termsAndConditions || "");
      setValue("actualAmount", duplicateData?.actualAmount || "");
      setValue("totalInvoiceAmount", duplicateData?.totalInvoiceAmount || "");
      setValue("customerGstIn", duplicateData?.customerGstIn || "");
      setValue("categoryType", duplicateData?.categoryType || null);
      setValue("otherCategoryType", duplicateData?.otherCategoryType || null);
      setValue("roundOff", duplicateData?.roundOff || null);


      if (duplicateData?.forms && duplicateData?.forms?.length > 0) {
        replace(
          duplicateData?.forms?.map((formItem) => ({
            item: formItem?.item || null,
            description: formItem?.description || null,
            qty: formItem?.qty || null,
            total: formItem?.total || null,
            price: formItem?.price || null,
          }))
        );
      }
      if (duplicateData?.paymentSplits?.length > 0) {
        paymentReplace(
          duplicateData?.paymentSplits?.map((item) => ({
            amountInSplit: item?.amountInSplit || null,
            description: item?.description || null,
            descriptionPercentage: item?.descriptionPercentage || null,
          }))
        );
      }
    }
  }, [setValue, replace, paymentReplace]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("duplicateData");
    };
  }, []);

  // Calculate actual amount based on qty and price
  useEffect(() => {
    const total = formValue?.reduce((sum, item) => {
      const qty = Number(item?.qty) || 0;
      const price = Number(item?.price) || 0;
      return sum + qty * price;
    }, 0);
    setValue("actualAmount", parseFloat(total.toFixed(2)));
  }, [formValue, setValue]);

  // Watching field values
  const discount = useWatch({ control, name: "discount" });
  const percentage = useWatch({ control, name: "percentage" });
  const actualAmount = useWatch({ control, name: "actualAmount" });
  const totalInvoiceAmount = useWatch({ control, name: "totalInvoiceAmount" });

  // Function to add a new row
  const handleAddRow = () => {
    append({ item: "", description: "", qty: 0, price: 0 });
  };

  // Function to remove a row
  const handleRemoveRow = (index) => {
    remove(index);
  };

  // When user types Discount
  const handleDiscountChange = (e) => {
    const value = Number(e.target.value) || null;
    setValue("discount", value);
    setValue("percentage", 0); // reset percentage
  };

  // When user types Percentage
  const handlePercentageChange = (e) => {
    const value = Number(e.target.value) || null;
    setValue("percentage", value);
    setValue("discount", 0); // reset discount
  };

  // Calculate Discount/Percentage and Total Invoice Amount
  useEffect(() => {
    if (!actualAmount) {
      setValue("totalInvoiceAmount", 0);
      return;
    }

    if (discount > 0) {
      const calculatedPercentage = (discount / actualAmount) * 100;
      const finalAmount = actualAmount - discount;
      setValue("percentage", parseFloat(calculatedPercentage.toFixed(2)));
      setValue("totalInvoiceAmount", parseFloat(finalAmount.toFixed(2)));
    } else if (percentage > 0) {
      const calculatedDiscount = (percentage / 100) * actualAmount;
      const finalAmount = actualAmount - calculatedDiscount;
      setValue("discount", parseFloat(calculatedDiscount.toFixed(2)));
      setValue("totalInvoiceAmount", parseFloat(finalAmount.toFixed(2)));
    } else {
      setValue("totalInvoiceAmount", actualAmount);
    }
  }, [discount, percentage, actualAmount, setValue]);

  useEffect(() => {
    if (paymentSplitting && paymentSplitting !== "other") {
      const splitCount = parseInt(paymentSplitting);
      if (splitCount > 0) {
        const amountPerSplit = (
          Number(totalInvoiceAmount) / splitCount
        ).toFixed(2);
        const splits = Array.from({ length: splitCount }).map((_, index) => ({
          amountInSplit: amountPerSplit,
          description: `Description Split ${index + 1}`,
        }));
        paymentReplace(splits); // sets all splits at once
      }
    }
  }, [paymentSplitting, totalInvoiceAmount, paymentReplace]);

  useEffect(() => {
    setValue("interest", interestStatus);
    setValue("convertt", convertedStatus);
  }, [setValue, interestStatus, convertedStatus]);

  // Toggle for "Interested" / "Not Interested"
  const handleLabelClick = () => {
    const newStatus =
      interestStatus === "Interested" ? "Not Interested" : "Interested";
    setInterestStatus(newStatus);
    setValue("interest", newStatus);
  };

  // Toggle for "Converted" / "Not Converted"
  const handleConvertedToggle = () => {
    const newStatus =
      convertedStatus === "Converted" ? "Not Converted" : "Converted";
    setConvertedStatus(newStatus);
    setValue("convertt", newStatus);
  };
  // Form Submit
  const onSubmit = (data) => {
    const formData = {
      billName: data?.billName || null,
      billNo: data?.billNo || null,
      branch: data?.branch || null,
      acNo: data?.acNo || null,
      bankName: data?.bankName || null,
      bankPhoneNumber: data?.bankPhoneNumber || null,
      billAlterNumber: data?.billAlterNumber || null,
      billCity: data?.billCity || null,
      billGstIn: data?.billGstIn || null,
      billLocality: data?.billLocality || null,
      billPhoneNumber: data?.billPhoneNumber || null,
      billPinCode: data?.billPinCode || null,
      billStreet: data?.billStreet || null,
      category: data?.category || null,
      city: data?.city || null,
      currentAccHolderName: data?.currentAccHolderName || null,
      customerName: data?.customerName || null,
      discount: data?.discount || null,
      doorNo: data?.doorNo || null,
      gstIn: data?.gstIn || null,
      ifscCode: data?.ifscCode || null,
      kindAttn: data?.kindAttn || null,
      locality: data?.locality || null,
      mobileNumber: data?.mobileNumber || null,
      natureOfBusiness: data?.natureOfBusiness || null,
      paymentSplitting: data?.paymentSplitting || null,
      percentage: data?.percentage || null,
      pincode: data?.pincode || null,
      proposal: data?.proposal || null,
      quotationDate: data?.quotationDate || null,
      quotationNo: data?.quotationNo || null,
      siteAddress: data?.siteAddress || null,
      siteVisitDate: data?.siteVisitDate || null,
      specifications: data?.specifications || null,
      state: data?.state || null,
      street: data?.street || null,
      forms: formValue || null,
      paymentSplits: paymentSplits || null,
      branchSelect: data?.branchSelect || null,
      interest: data?.interest || null,
      convertt: data?.convertt || null,
      customerGstIn: data?.customerGstIn || null,
      termsAndConditions: data?.termsAndConditions || null,
      actualAmount: data?.actualAmount || null,
      totalInvoiceAmount: data?.totalInvoiceAmount || null,
      categoryType: data?.categoryType || null,
      otherCategoryType: data?.otherCategoryType || null,
      roundOff: data?.roundOff || null
    };
    setProformaData(formData);
    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">
              {state?.id ? <>Edit Quotation </> : <>Quotation Add</>}
            </div>

            <div
              style={{
                width: "35%",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <div className="header_proforma">
                <input
                  list="customers"
                  placeholder="Select customer"
                  className="branchSelect"
                  value={selectedValue}
                  onChange={(e) => {
                    setSelectedValue(e.target.value);
                  }}
                />
                <datalist id="customers">
                  {details?.map((item, index) => (
                    <option
                      key={index}
                      value={`${item.customerName} : ${item.mobileNumber}`}
                    />
                  ))}
                </datalist>
              </div>
              <div className="header_proforma">
                <Controller
                  name="branchSelect"
                  control={control}
                  rules={{ required: "Branch selection is required" }}
                  render={({ field }) => (
                    <select
                      {...field}
                      className="branchSelect"
                      onChange={(e) => {
                        field.onChange(e); // Update form state
                        setSelectedBranch(e.target.value); // Update local state
                      }}
                      value={field.value || ""}
                    >
                      <option value="">-Select Branch-</option>
                      {storedBranchArray?.map((branch, index) => (
                        <option key={index} value={branch}>
                          {branch}
                        </option>
                      ))}
                    </select>
                  )}
                />
                {errors.branchSelect && (
                  <p style={{ color: "red" }}>{errors.branchSelect.message}</p>
                )}
              </div>
            </div>
          </header>

          <section className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form_OverAllContainer">
                <div className="commonForm_container">
                  <div className="input_container">
                    <label className="inputLabel">Quotation No</label>
                    <Controller
                      control={control}
                      name="quotationNo"
                      rules={{
                        required: "Quotation number is required",
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <input
                            {...field}
                            type="text"
                            className="commonInputCss"
                          />
                          {error && (
                            <span
                              className="errorText"
                              style={{ color: "red" }}
                            >
                              {error.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Date</label>
                    <Controller
                      control={control}
                      name="quotationDate"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="date"
                          className="commonInputCss"
                        // placeholder="DD/MM/YYYY"
                        />
                        // <DateField {...field} commonInputCss="commonInputCss" />
                      )}
                    />
                  </div>

                  <div className="input_container">
                    <label className="inputLabel">Customer Name</label>
                    <Controller
                      control={control}
                      name="customerName"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Kind Attn</label>
                    <Controller
                      control={control}
                      name="kindAttn"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Mobile Number</label>
                    <Controller
                      control={control}
                      name="mobileNumber"
                      rules={{
                        required: "Mobile number is required",
                        pattern: {
                          value: /^[6-9]\d{9}$/,
                          message: "Enter a valid 10-digit mobile number",
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <input
                            {...field}
                            type="tel"
                            className="commonInputCss"
                          />
                          {error && (
                            <span
                              className="errorText"
                              style={{ color: "red" }}
                            >
                              {error.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Gst In</label>
                    <Controller
                      control={control}
                      name="customerGstIn"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Door No</label>
                    <Controller
                      control={control}
                      name="doorNo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Street</label>
                    <Controller
                      control={control}
                      name="street"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Locality</label>
                    <Controller
                      control={control}
                      name="locality"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">City</label>
                    <Controller
                      control={control}
                      name="city"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">State</label>
                    <Controller
                      control={control}
                      name="state"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Pincode</label>
                    <Controller
                      control={control}
                      name="pincode"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Nature of Business</label>
                    <Controller
                      control={control}
                      name="natureOfBusiness"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Site Address</label>
                    <Controller
                      control={control}
                      name="siteAddress"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Site Visit Date</label>
                    <Controller
                      control={control}
                      name="siteVisitDate"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="date"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Category</label>
                    <Controller
                      control={control}
                      name="categoryType"
                      render={({ field }) => (
                        <select {...field} className="commonInputCss">
                          <option value="">Select Category Type</option>
                          <option value="Residential">Residential</option>
                          <option value="Commercial">Commercial</option>
                          <option value="Others">Others</option>
                        </select>
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">
                      Other Category (Optional)
                    </label>
                    <Controller
                      control={control}
                      name="otherCategoryType"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="proposalInput_container">
                    <label className="inputLabel">Proposal</label>
                    <Controller
                      control={control}
                      name="proposal"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                </div>

                {fields?.map((item, index) => {
                  const qty = Number(formValue[index]?.qty) || 0;
                  const price = Number(formValue[index]?.price) || 0;
                  const total = qty * price;

                  return (
                    <div key={item.id} className="appendForm_container">
                      <div className="ItemInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Item</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.item`}
                          render={({ field }) => (
                            <input {...field} className="commonInputCss" />
                          )}
                        />
                      </div>
                      <div className="descriptionInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Description</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.description`}
                          render={({ field }) => (
                            <input {...field} className="commonInputCss" />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">QTY</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.qty`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="number"
                              placeholder="Qty"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Price</label>
                        )}

                        <Controller
                          control={control}
                          name={`formValue.${index}.price`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="number"
                              placeholder="Price"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Total</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.total`}
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <input
                              value={total || ""}
                              readOnly
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="appendBtnContainer">
                        <div className="appendBtn" onClick={handleAddRow}>
                          <img
                            className="mb-1"
                            src={exportImage?.addIcon}
                            alt="addIcon"
                          />
                        </div>
                        {index !== 0 && (
                          <div
                            className="appendBtn"
                            onClick={() => handleRemoveRow(index)}
                          >
                            <img
                              className="mb-1"
                              src={exportImage?.deleteIcon}
                              alt="deleteIcon"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className="SpecificationsForm_container">
                  <div className="SpecificationsInput_container ">
                    <label className="inputLabel">Specifications</label>
                    <Controller
                      control={control}
                      name="specifications"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <textarea
                          onChange={onChange}
                          value={value}
                          className="commonInputCss h-75"
                        ></textarea>
                      )}
                    />
                  </div>

                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Acutal Amount</label>

                      <Controller
                        control={control}
                        name="actualAmount"
                        render={({ field }) => (
                          <input
                            {...field}
                            readOnly
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Discount</label>
                      <Controller
                        control={control}
                        name="discount"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            placeholder="Discount"
                            onChange={handleDiscountChange}
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Percentage %</label>
                      <Controller
                        control={control}
                        name="percentage"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="number"
                            placeholder="Discount %"
                            onChange={handlePercentageChange}
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div>
                    <div className="commonForm_container">
                      <div className="input_container">
                        <label className="inputLabel">Invoice Amount</label>
                        <Controller
                          control={control}
                          name="totalInvoiceAmount"
                          render={({ field }) => (
                            <input
                              {...field}
                              readOnly
                              className="commonInputCss"
                              placeholder="Total Invoice Amount"
                            />
                          )}
                        />
                      </div>
                      <div className="input_container">
                        <label className="inputLabel">Round Off</label>
                        <Controller
                          control={control}
                          name="roundOff"
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                              placeholder="Round Off"
                            />
                          )}
                        />
                      </div>
                      <div className="input_container">
                        <label className="inputLabel">Payment splitting</label>
                        <Controller
                          control={control}
                          name="paymentSplitting"
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <select
                              onChange={onChange}
                              value={value}
                              className="commonInputCss"
                            >
                              <option value=""> --Select-- </option>
                              <option value="1"> Single </option>
                              <option value="2"> Double </option>
                              <option value="3"> Triple </option>
                              <option value="4"> Fourth </option>
                              <option value="other"> Manual Splitting </option>
                            </select>
                          )}
                        />
                      </div>
                      {paymentSplitting === "other" && (
                        <div className="qtyInput_container">
                          <label className="inputLabel"> </label>
                          <Controller
                            control={control}
                            name="descriptionCount"
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                placeholder="Enter number"
                                className="commonInputCss"
                              />
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="descriptionSpiltContainer">
                    {paymentSplit?.map((field, index) => (
                      <div key={field.id} className="descriptionSpiltCss">
                        <div className="w-50">
                          <Controller
                            control={control}
                            name={`paymentSplits.${index}.amountInSplit`}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                placeholder="0.00"
                                className="commonInputCss"
                              />
                            )}
                          />
                        </div>

                        <div className="w-75 text-center">
                          <Controller
                            control={control}
                            name={`paymentSplits.${index}.descriptionPercentage`}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="number"
                                placeholder="%"
                                className="commonInputCss"
                                step="any"
                                style={{ display: "none" }}
                              />
                            )}
                          />
                        </div>

                        <div className="w-75 text-center">
                          <Controller
                            control={control}
                            name={`paymentSplits.${index}.description`}
                            render={({ field }) => (
                              <input
                                {...field}
                                type="text"
                                placeholder={`Description Split ${index + 1}`}
                                className="commonInputCss"
                              />
                            )}
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Category</label>
                      <Controller
                        name="category"
                        control={control}
                        rules={{ required: "Category selection is required" }}
                        render={({ field }) => (
                          <select
                            {...field}
                            className="commonInputCss"
                            onChange={(e) => {
                              field.onChange(e);
                              setSelectedCategory(e.target.value); // Optional: local state if needed
                            }}
                            value={field.value || ""}
                          >
                            <option value="">--Select Category--</option>
                            {categoryArray?.map((data, index) => (
                              <option key={index} value={data}>
                                {data}
                              </option>
                            ))}
                          </select>
                        )}
                      />
                      {errors.category && (
                        <p style={{ color: "red" }}>
                          {errors.category.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="commonForm_container">
                    <div className="proposalInput_container">
                      <label className="inputLabel">Terms & Condition</label>

                      <Controller
                        control={control}
                        name="termsAndConditions"
                        render={({ field }) => (
                          <textarea {...field} className="termsConditionCss" />
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="billDetails_container">
                  <header className="header_title">Branch Details</header>
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Name</label>
                      <Controller
                        control={control}
                        name="billName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">No</label>
                      <Controller
                        control={control}
                        name="billNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Street</label>
                      <Controller
                        control={control}
                        name="billStreet"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Locality</label>
                      <Controller
                        control={control}
                        name="billLocality"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">City</label>
                      <Controller
                        control={control}
                        name="billCity"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Pin code</label>
                      <Controller
                        control={control}
                        name="billPinCode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Phone Number</label>
                      <Controller
                        control={control}
                        name="billPhoneNumber"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Alter Number</label>
                      <Controller
                        control={control}
                        name="billAlterNumber"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">GST In</label>
                      <Controller
                        control={control}
                        name="billGstIn"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="bankDetails_container">
                  <header className="header_title">Bank Details</header>
                  {!bankDetails || bankDetails == "" ? (
                    <h6 style={{ color: "red" }}>
                      Please Select Branch (or) Bank Details Not Available
                    </h6>
                  ) : null}
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Account Holder Name</label>
                      {/* <Controller
                        control={control}
                        name="currentAccHolderName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      /> */}
                      <Controller
                        control={control}
                        name="currentAccHolderName"
                        rules={{
                          required: "Bank details are required. Please select bank details.",
                        }}
                        render={({
                          field: { onChange, onBlur, value, ref },
                          fieldState: { error },
                        }) => (
                          <>
                            <input
                              type="text"
                              list="bankList"
                              onBlur={onBlur}
                              ref={ref}
                              value={value || ""}
                              onChange={(e) => {
                                const selectedText = e.target.value;
                                setSelectedBankValue(selectedText);

                                const match = bankDetails && bankDetails?.find(
                                  (data) =>
                                    `${data?.currentAccHolderName} : ${data?.accNo}` ===
                                    selectedText
                                );

                                if (match) {
                                  onChange(match?.currentAccHolderName); // store only the name
                                } else {
                                  onChange(""); // clear if unmatched
                                }
                              }}
                              className="commonInputCss"
                              placeholder="Select bank details"
                            />

                            <datalist id="bankList">
                              {bankDetails && bankDetails?.map((data, index) => (
                                <option
                                  key={index}
                                  value={`${data.currentAccHolderName} : ${data.accNo}`}
                                />
                              ))}
                            </datalist>

                            {error && (
                              <span style={{ color: "red", fontSize: "12px" }}>
                                {error?.message}
                              </span>
                            )}
                          </>
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Bank Name</label>
                      <Controller
                        control={control}
                        name="bankName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">A/C No</label>
                      <Controller
                        control={control}
                        name="acNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">IFSC Code</label>
                      <Controller
                        control={control}
                        name="ifscCode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Branch & Type</label>
                      <Controller
                        control={control}
                        name="branch"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Gpay /Upi Number</label>
                      <Controller
                        control={control}
                        name="bankPhoneNumber"
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            className="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="submitBtnContainer">
                {state?.id ? (
                  <>
                    <button className="submitBtn" type="submit">
                      {postLoading || putLoading ? (
                        <>
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </>
                      ) : (
                        <> Submit</>
                      )}
                    </button>
                    <label
                      className="statusconvert"
                      style={{
                        lineHeight: "44px",
                        textAlign: "center",
                        cursor: "pointer",
                      }}
                      onClick={handleLabelClick}
                    >
                      {interestStatus}
                    </label>

                    <select
                      name="interest"
                      style={{ display: "none" }}
                      value={interestStatus}
                      onChange={(e) => {
                        setInterestStatus(e.target.value);
                        setValue("interest", e.target.value);
                      }}
                    >
                      <option value="Interested">Interested</option>
                      <option value="Not Interested">Not Interested</option>
                    </select>
                    <label
                      className="statusconvert"
                      style={{
                        lineHeight: "44px",
                        textAlign: "center",
                        cursor: "pointer",
                        marginLeft: "10px",
                      }}
                      onClick={handleConvertedToggle}
                    >
                      {convertedStatus}
                    </label>
                    <select
                      name="convertt"
                      style={{ display: "none" }}
                      value={convertedStatus}
                      onChange={(e) => {
                        setConvertedStatus(e.target.value);
                        setValue("convertt", e.target.value);
                      }}
                    >
                      <option value="Converted">Converted</option>
                      <option value="Not Converted">Not Converted</option>
                    </select>
                  </>
                ) : (
                  <>
                    <button className="submitBtn" type="submit">
                      {postLoading || putLoading ? (
                        <>
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </>
                      ) : (
                        <> Get Quotation</>
                      )}
                    </button>
                  </>
                )}
              </div>
            </form>
          </section>
        </div>
      </div>
      {/* <Alert
        open={postAlert}
        setPutAlert={setPutAlert}
        postAlert={postAlert}
        // state={state}
        // upData={putMutate}
        putAlert={putAlert}
        // mutate={postMutate}
        navigates="/"
        // id={state?.id}
        add={true}
        onCloses={setPostAlert}
        // setPutAlert={setPutAlert}
      /> */}
      <Popup
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Quotation Added Successfully!"
        updatemessage="Quotation Updated Successfully!"
        state={state?.id}
        navigateUrl="/quatation/quotationInvoice"
        updateUrl="/quatation/quotationView"
        proformaData={proformaData}
      />
    </>
  );
}
